import { Stack } from "@mui/material";
import type { InitiatePaymentFormData } from "Components/Merchant/Initiate/InitiatePaymentForm/schema";
import { BankingAccountSelector } from "Components/Shared/Inputs/Form/BankingAccountSelector";
import { FormInput } from "Components/Shared/Inputs/Form/FormInput";
import { useIsCurrentUserMerchant } from "Hooks/useIsCurrentUserMerchant";
import type { BankAccountListItem } from "Infrastructure/Api/Api";
import { Resources, useResource } from "Translations/Resources";
import type { Control } from "react-hook-form";

const FormResources = Resources.Merchant.Initiate.Form;

type Props = {
  control: Control<InitiatePaymentFormData>;
  bankingAccounts: Array<BankAccountListItem>;
};

export const FormFields = ({ control, bankingAccounts }: Props) => {
  const { t } = useResource();
  const isMerchant = useIsCurrentUserMerchant();

  return (
    <Stack gap={4} height="100%">
      <BankingAccountSelector
        name="bankAccountID"
        control={control}
        label={
          isMerchant
            ? t(FormResources.BusinessAccountSelectTitle)
            : t(FormResources.PersonalAccountSelectTitle)
        }
        bankAccounts={bankingAccounts}
      />
      <FormInput
        control={control}
        name="amount"
        label={t(Resources.FormLabels.Amount)}
        type="number"
      />
    </Stack>
  );
};
